<div class="jumbotron">
    <h1 class="text-center">{{ i18n._8505_VIDEO_TUTORIALS | translate }}</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="container-fluid">
    <div class="row intro">
        <div class="col-12">
            <h2>
                {{ i18n._8506_WELCOME_TO_COMPAS_VIDEO_TRAINING | translate }}
            </h2>
            <div
                class="w-100"
                [innerHTML]="i18n._8507_DESCRIPTION | translate"
            ></div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-3 col-lg-2">
            <ng-container *ngFor="let i of playlists">
                <cmps-vimeo-text-playlist [list]="i"></cmps-vimeo-text-playlist>
            </ng-container>
        </div>
        <div class="col-12 col-md-9 col-lg-10">
            <ng-container *ngIf="!hasPendingData">
                <div class="row player">
                    <div class="col-12 col-xl-8">
                        <cmps-vimeo-player
                            (event)="onPlayerEvent($event)"
                            #player="cmpsVimeoPlayer"
                        ></cmps-vimeo-player>
                        <cmps-vimeo-now-playing
                            [now]="currentPlaylistItem"
                            [next]="nextPlaylistItem"
                        ></cmps-vimeo-now-playing>
                        <div>
                            <ng-container
                                *ngFor="
                                    let i of currentPlaylistItem?.attachments;
                                    let last = last
                                "
                            >
                                <span>
                                    <a
                                        [href]="i.uri"
                                        target="_blank"
                                        >{{ i.name }}</a
                                    >
                                </span>
                                <span
                                    class="mr-1 ml-1"
                                    *ngIf="!last"
                                    >|</span
                                >
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-12 col-xl-4">
                        <cmps-vimeo-playlist
                            [isPlayerQueue]="true"
                            [list]="currentPlaylist"
                            [currentItem]="currentPlaylistItem"
                        ></cmps-vimeo-playlist>
                    </div>
                </div>
                <div class="row playlists">
                    <div
                        class="col-12 col-lg-6 col-xl-3"
                        *ngFor="let i of playlists"
                    >
                        <cmps-vimeo-playlist [list]="i"></cmps-vimeo-playlist>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
